import { render } from "./FooterDisclaimer.vue?vue&type=template&id=7269a4c6&scoped=true"
import script from "./FooterDisclaimer.vue?vue&type=script&lang=js"
export * from "./FooterDisclaimer.vue?vue&type=script&lang=js"

import "./FooterDisclaimer.vue?vue&type=style&index=0&id=7269a4c6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7269a4c6"]])

export default __exports__